import { InterstateRegistryProvider } from '../InterstateRegistryProvider';
import { InterstateBaseThemeProvider } from '../InterstateBaseThemeProvider';
import { interstateThemeRegistry } from '../InterstateTheming';
import { InterstateCSSBaseline } from './InterstateCSSBaseline';
import { ToastProvider } from '../Toast/Toast/ToastProvider';
import { ToasterStoreContext } from '../Toast/Toast/ToasterStoreContext';
import { useContext } from 'react';

/**
 * Provides the Interstate theme.  If the provided theme name is in the registry it will be loaded.
 * @param {string}          themeName           The theme name to use.  If the name is not in the registry then
 * @param {node[]}          children            The child nodes to render
 * @param {string}          applicationName     The name of the application
 * @param {themeRegistries} themeRegistries     The list of theme registries to use for the application
 * @param {boolean}         loadCSSBaseline     If true the CSS baseline will be loaded, default is true
 * @returns {JSX.Element}
 * @constructor
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const InterstateThemeProvider = _ref => {
  let {
    themeName,
    themeRegistries,
    applicationName,
    children,
    loadCSSBaseline
  } = _ref;
  const toastContext = useContext(ToasterStoreContext);
  return /*#__PURE__*/_jsx(InterstateRegistryProvider, {
    themeRegistries: themeRegistries || interstateThemeRegistry,
    children: /*#__PURE__*/_jsxs(InterstateBaseThemeProvider, {
      themeName: themeName || 'Interstate',
      scopeName: applicationName,
      applicationName: applicationName,
      children: [/*#__PURE__*/_jsx(InterstateCSSBaseline, {
        loadCSSBaseline: loadCSSBaseline
      }), !toastContext ? /*#__PURE__*/_jsx(ToastProvider, {
        children: children
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })]
    })
  });
};